export default __webpack_public_path__ + "static/media/move-material-2.2965ca87.webp";